import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Lists from "@/pages/Lists";
import ListDetail from "@/pages/ListDetail";
import Campaigns from "@/pages/Campaigns";
import CampaignComposer from "@/pages/CampaignComposer";
import CampaignReport from "@/pages/CampaignReport";
import Settings from "@/pages/Settings";
import AgentCampaigns from "@/pages/AgentCampaigns";
import AgentCampaignDetail from "@/pages/AgentCampaignDetail";
import Login from "@/pages/Login";
import { AuthProvider, useAuth } from "@/lib/auth";
import { getSettings, updateSettings } from "@/lib/api";

function ProtectedRoutes() {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] text-sm text-[#94A3B8]">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return <Layout />;
}

function AppRoutes() {
  const { user } = useAuth();
  useEffect(() => {
    if (!user) return;
    // Auto-set backend_url in settings so tracking pixel works
    (async () => {
      try {
        const s = await getSettings();
        const backendUrl = process.env.REACT_APP_BACKEND_URL;
        if (backendUrl && s.backend_url !== backendUrl) {
          await updateSettings({ backend_url: backendUrl });
        }
      } catch (e) {
        /* ignore */
      }
    })();
  }, [user]);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoutes />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/lists" element={<Lists />} />
        <Route path="/lists/:id" element={<ListDetail />} />
        <Route path="/campaigns" element={<Campaigns />} />
        <Route path="/campaigns/new" element={<CampaignComposer />} />
        <Route path="/campaigns/:id/edit" element={<CampaignComposer />} />
        <Route path="/campaigns/:id/report" element={<CampaignReport />} />
        <Route path="/agent-campaigns" element={<AgentCampaigns />} />
        <Route path="/agent-campaigns/:id" element={<AgentCampaignDetail />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster richColors position="top-right" />
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
